/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentItemVo } from './PaymentItemVo';
import {
    PaymentItemVoFromJSON,
    PaymentItemVoFromJSONTyped,
    PaymentItemVoToJSON,
    PaymentItemVoToJSONTyped,
} from './PaymentItemVo';
import type { BillEnumItem } from './BillEnumItem';
import {
    BillEnumItemFromJSON,
    BillEnumItemFromJSONTyped,
    BillEnumItemToJSON,
    BillEnumItemToJSONTyped,
} from './BillEnumItem';

/**
 * 
 * @export
 * @interface PaymentListVo
 */
export interface PaymentListVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PaymentListVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PaymentListVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PaymentListVo
     */
    totalRecord?: number;
    /**
     * 支付单记录列表
     * @type {Array<PaymentItemVo>}
     * @memberof PaymentListVo
     */
    records?: Array<PaymentItemVo>;
    /**
     * 账单类型列表
     * @type {Array<BillEnumItem>}
     * @memberof PaymentListVo
     */
    billTypeList?: Array<BillEnumItem>;
}

/**
 * Check if a given object implements the PaymentListVo interface.
 */
export function instanceOfPaymentListVo(value: object): value is PaymentListVo {
    return true;
}

export function PaymentListVoFromJSON(json: any): PaymentListVo {
    return PaymentListVoFromJSONTyped(json, false);
}

export function PaymentListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(PaymentItemVoFromJSON)),
        'billTypeList': json['billTypeList'] == null ? undefined : ((json['billTypeList'] as Array<any>).map(BillEnumItemFromJSON)),
    };
}

export function PaymentListVoToJSON(json: any): PaymentListVo {
    return PaymentListVoToJSONTyped(json, false);
}

export function PaymentListVoToJSONTyped(value?: PaymentListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(PaymentItemVoToJSON)),
        'billTypeList': value['billTypeList'] == null ? undefined : ((value['billTypeList'] as Array<any>).map(BillEnumItemToJSON)),
    };
}

